import { RowBelow } from 'almanac-ui/icons'
import { Revision } from 'types'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { RevisionAcceptAction, useAcceptRevision } from 'hooks/queries/layers/revisions/useAcceptRevision'
import { useQueryClient } from 'react-query'
import { layersKeys } from 'hooks/queries/layers/layersKeys'
import { ArrowCurveLeftDown } from 'blaze-ui/icons'
import { Button } from 'blaze-ui/Button'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'

interface Props {
  revision: Revision
}

export const AddBelowButton = observer(({ revision }: Props) => {
  const { isMobile } = useResponsiveDesign()
  const { drawersStore } = useRootStore()
  const queryClient = useQueryClient()
  const { mutate: acceptRevision, isLoading } = useAcceptRevision(
    {
      articleKey: revision.layer.article_id,
      layerId: revision.layer.id,
      id: revision.id,
    },
    {
      onSuccess: () => {
        drawersStore.closeDrawer()
        queryClient.invalidateQueries(layersKeys.revision(revision.layer.id, revision.id))
      },
    },
  )

  const handlePress = () => {
    acceptRevision(
      { accept_action: RevisionAcceptAction.InsertBelow },
    )
  }

  return isMobile ? (
    <Button
      frontIcon={ArrowCurveLeftDown}
      fullWidth
      variant="tertiary"
      size="lg"
      onPress={handlePress}
      isDisabled={isLoading}
    >
      Add Below the Selection
    </Button>
  ) : (
    <Button frontIcon={RowBelow} variant="secondary" size="sm" onPress={handlePress} isDisabled={isLoading}>
      Add Below
    </Button>
  )
})
